/**
 * Configuration API client
 *
 * GW-639: Handles fetching platform configuration including pricing defaults.
 * Extends BaseApiClient for authentication, error handling, and type-safe requests.
 */

import { BaseApiClient } from './baseApiClient';

import type { PricingConfig } from '@gw/ui/types';

class ConfigAPI extends BaseApiClient {
  /**
   * Fetch platform pricing configuration
   * GET /config/pricing
   * GW-668: Updated path and response handling
   */
  async getPricingConfig(): Promise<PricingConfig> {
    return this.get<PricingConfig>('/config/pricing');
  }
}

export const configApi = new ConfigAPI();
